type Props = {
  className?: string
}

const SRC = '/brand/metatrader-5-logo.png'

/** Official MetaTrader 5 logo supplied for the ads landing. */
export function MetaTraderMark({ className = '' }: Props) {
  return (
    <span className={`tl-mt5 ${className}`.trim()}>
      <img src={SRC} alt="MetaTrader 5" width={140} height={120} />
    </span>
  )
}
